import { RadioButton, Typography } from 'mobily-ui-library/lib';
import { useTranslation } from 'react-i18next';

import './RadioSelection.scss';

type RadioProps = {
    rtl: boolean;
    dir: any;
    radioValue: string;
    handleSelectType: (e: any) => void;
}

function RadioSelection({ rtl, dir, radioValue, handleSelectType }: RadioProps) {
    const { t } = useTranslation();
    return (
        <div className='radioSection'>
            <Typography rtl={rtl}>{t('Select_type')}</Typography>
            <div style={{ direction: dir }}>
                <RadioButton labelName={t('For_Individuals')} id={'individuals'} value={'individuals'} name={'selectType'} onChange={handleSelectType} checked={radioValue === 'individuals'} />
                <RadioButton labelName={t('For_Corporate')} id={'corporate'} value={'corporate'} name={'selectType'} onChange={handleSelectType} checked={radioValue === 'corporate'} />
            </div>
        </div>
    )
}

export default RadioSelection